import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  cardtag: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-radius: 4px;
    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 3px 3px -2px rgba(0, 0, 0, 0.2);
    gap: 10px;
    padding: 0 5px;
    @media (max-width: 700px) {
      flex-direction: column;
      padding: 15px;
      width: calc(100% - 32px);
    }
  `,
  cardtag_blue: css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.palette.common.white};
    background-color: ${theme.palette.secondary.main};
    padding: 5px 15px;
    border-radius: 4px;
  `,
  cardtag_icon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.palette.common.white};
    background-color: ${theme.palette.warning.main};
    border-radius: 4px;
    padding: 5px 15px;
    width: 40px;
  `,
  cardtag_orange: css`
    color: ${theme.palette.warning.main};
    padding: 10px 0;
    font-weight: 900;
  `
};
